import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-services-in-product',
  templateUrl: './services-in-product.component.html',
  styleUrls: ['./services-in-product.component.css']
})
export class ServicesInProductComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;



  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.model.choose_report = '3';
    this.servicesInProduct();
    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  chooseReport() {
    if (this.model.choose_report == '0') {
      this.router.navigate(['/productReport']);
    } else if (this.model.choose_report == '1') {
      this.router.navigate(['/productUsageReport']);
    } else if (this.model.choose_report == '2') {
      this.router.navigate(['/productInService']);
    } else if (this.model.choose_report == '3') {
      // this.router.navigate(['/servicesInproduct']);
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  servicesInProduct() {
    this.loginservice.servicesInProduct(this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error servicesInProduct API');
          this.showLoader = false;
        });
  }

  @ViewChild('excel_table') table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Services In Product.xlsx');

  }
  public mprint() {
    window.print();
  }
}







// WEBPACK FOOTER //
// ./src/app/services-in-product/services-in-product.component.ts